import router from "./router";
// import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// 未登录不拦截的路由
// const whitelistRouter = ['/404']
router.beforeEach(function (to, from, next) {
  NProgress.start();
  // set page title
  document.title = getPageTitle(to.meta.title);
  next();
});
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});